import React from "react";

const CustomButton = ({
  onClick,
  className,
  backgroundColor,
  color,
  border,
  padding,
  margin,
  fontFamily,
  fontSize,
  fontWeight,
  width,
  height,
  borderRadius,
  children,
}) => {
  return (
    <button
      onClick={onClick}
      className={`d-flex justify-content-center align-items-center ${className}`}
      style={{
        backgroundColor: backgroundColor,
        fontWeight: fontWeight,
        color: color,
        border: border,
        padding: padding,
        margin: margin,
        fontSize: fontSize,
        fontFamily: fontFamily,
        width: width,
        height: height,
        borderRadius: borderRadius,
      }}
    >
      {children}
    </button>
  );
};

export default CustomButton;
